module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images-old/harley-clark-f599431a00d68c6a59b627a2e49ab172.jpg";